module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/has-binary/~/isarray/index.js
// module id = ../../../../has-binary/node_modules/isarray/index.js
// module chunks = 3